<template>
    <v-toolbar color="grey lighten-2" flat height="24em" absolute tabs style="top: 85px;">
      <template slot="extension">
        <v-tabs v-if="!historicTournamentSelectionMode" v-model="currentTab" show-arrows centered flat icons-and-text class="pb-4" color="grey lighten-2">
          <v-tab :key="tab.id" @click="handleTournamentSelection(tab)" v-for="tab in torneos">
            <span>{{ tab.description }}</span>
            <v-icon>{{ tab.icon }}</v-icon>
          </v-tab>
        </v-tabs>
          <v-icon @click="handleCleanHistoricSelectionMode" class="clean-tournaments-filters" color="black" v-if="historicTournamentSelectionMode">mdi-close-circle-outline</v-icon>
        <SelectorExtra
          v-if="historicTournamentSelectionMode"
          :tabs="extraTabs"
          @extraTabSelection="handleExtraTabSelection"
        >
      </SelectorExtra>
      </template>
    </v-toolbar>
</template>

<script>

import SelectorExtra from './SelectorExtra.vue'
export default {

  data () {
    return {
      currentTab: null,
      historicSelectionCurrentTab: null
    }
  },
  components: {
    SelectorExtra
  },
  props: {
    torneos: [],
    historicTournamentSelectionMode: Boolean,
    extraTabs: [],
    urlTournamentAndFechaSelection: Boolean,
    urlTournamentSelection: null
  },
  methods: {
    selectFirstPrimeraTournament () {
      for (let index = 0; index < this.torneos.length; index++) {
        if (this.torneos[index].category === 1) {
          this.currentTab = index
          return this.currentTab
        }
      }
      this.currentTab = 0
    },
    selectUrlTournament () {
      for (let index = 0; index < this.torneos.length; index++) {
        if (this.torneos[index].id.toString() === this.urlTournamentSelection) {
          this.currentTab = index
          return this.currentTab
        }
      }
      this.currentTab = 0
    },
    handleTournamentSelection (tournamentSelected) {
      this.$emit('tournamentSelection', tournamentSelected)
    },
    handleExtraTabSelection (extraTabSelected) {
      this.$emit('extraTabSelection', extraTabSelected)
    },
    handleCleanHistoricSelectionMode () {
      this.$emit('cleanHistoricSelectionMode')
    }
  },
  created () {
  },
  watch: {
    async torneos () {
      if (!this.urlTournamentAndFechaSelection) {
        this.selectFirstPrimeraTournament()
        this.$emit('currentTournament', this.torneos[this.currentTab])
      } else {
        this.selectUrlTournament()
        this.$emit('currentTournament', this.torneos[this.currentTab])
      }
    }
  }
}
</script>

<style scoped>
.top-spacing {
  margin-top: 5em;
}
.clean-tournaments-filters{
  align-self: self-start;
  cursor: pointer;
}
</style>
